import { ApiFormView, ApiFormViewElement } from "@/types/forms/form-view.types.ts";
import {
  ApiFormElementType,
  ApiFormResultAnswer,
  ApiFormResultCompensationLine,
  ApiFormType,
} from "@/types/forms/form.types.ts";
import { UseMutationResult, UseQueryResult } from "@tanstack/react-query";
import { FieldErrors } from "react-hook-form";
import { ApiFile } from "@/types/common.types.ts";
import { ApiEmployee } from "@/types/employees/employee.types.ts";

export type QuestionnaireAnswerType =
  | Date
  | null
  | number
  | string
  | number[]
  | string[]
  | ApiFile[]
  | ApiFormResultCompensationLine[]
  | undefined;

export type QuestionnaireFormValueTypes = {
  [key: string]: QuestionnaireAnswerType;
};

export interface QuestionnaireParams {
  employeeId?: number;
  questionnaireId: number;
  respondentUuid?: string;
  enabled: boolean;
}

export interface SubmitParams {
  employeeId: number;
  questionnaireId: number;
  answers: ApiFormResultAnswer[];
}

export interface QuestionnaireType {
  type: ApiFormType;
  hooks: {
    useGetQuestionnaireResults: (params: QuestionnaireParams) => UseQueryResult<ApiFormView>;
    useGetQuestionnaireForm: (params: QuestionnaireParams) => UseQueryResult<ApiFormView>;
    useSubmitQuestionnaire: () => UseMutationResult<void, Error, SubmitParams, unknown>;
    useSaveDraft: () => UseMutationResult<void, Error, SubmitParams, unknown>;
  };
  // navigateAfterSubmit: string;
}

export interface QuestionnaireContextType {
  questionnaireId: number;
  currentPage: number;
  totalPages: number;
  isLastPage: boolean;
  questionnaireForm: ApiFormView | undefined;
  // questionnaireResults: any;
  // currentAnswers: Record<string, any>;
  // lastSaved: Date | null;
  errors: FieldErrors<Record<string, string | string[]>>;
  isSubmitting: boolean;
  // isCompleted: boolean;
  isSaving: boolean;
  isAnonymous: boolean;
  nextPage: () => void;
  previousPage: () => void;
  // saveDraft: () => Promise<void>;
  submitQuestionnaire: () => void;
  questionnaireType: QuestionnaireType;
  targetEmployee?: ApiEmployee;
}

export interface QuestionnaireProviderProps {
  type: ApiFormType;
  id: number | string | undefined;
  children: React.ReactNode;
  onAfterSubmit?: () => void;
  isAnonymous?: boolean;
  targetEmployee?: ApiEmployee;
}

export interface QuestionnaireHandle {
  saveDraft: () => Promise<void>;
}

export const getFormKey = (element: ApiFormViewElement, isForComment: boolean = false) => {
  const additionalKey = isForComment ? "_comment" : "";
  switch (element.type) {
    case ApiFormElementType.scale:
      return `scale_${element.id}${additionalKey}`;
    case ApiFormElementType.select:
      return `select_${element.id}${additionalKey}`;
    case ApiFormElementType.open_answer:
      return `open_answer_${element.id}${additionalKey}`;
    case ApiFormElementType.employee_nps:
      return `employee_nps_${element.id}${additionalKey}`;
    case ApiFormElementType.text:
      return `text_${element.id}${additionalKey}`;
    case ApiFormElementType.goals:
      return `goals_${element.id}${element.reference_id}${additionalKey}`;
    case ApiFormElementType.write_to_field:
      return `write_to_field_${element.id}${additionalKey}`;
    case ApiFormElementType.file:
      return `file_${element.id}${additionalKey}`;
  }
};
